export default __webpack_public_path__ + "static/media/exportTemplate.cd8bbcdc.docx";